module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑商家' : '新增商家'))])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "maxlength": "20",
      "title": "商家名称",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.username),
      callback: function($$v) {
        _vm.$set(_vm.params, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.username"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "email",
      "maxlength": "11",
      "title": "登录账号",
      "placeholder": "请输入手机号码",
      "isMust": "true"
    },
    model: {
      value: (_vm.params.phone),
      callback: function($$v) {
        _vm.$set(_vm.params, "phone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.phone"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "maxlength": "20",
      "title": "登录密码",
      "placeholder": "默认：888888",
      "disabled": "disabled"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_vm._m(0), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-url": _vm.params.logo_url,
      "on-success": _vm.handleUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pic-tips m-l-10"
  }, [_vm._v("建议尺寸：200*200")])], 1), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "maxlength": "20",
      "title": "神马付商户ID"
    },
    model: {
      value: (_vm.params.partnerId),
      callback: function($$v) {
        _vm.$set(_vm.params, "partnerId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.partnerId"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "type": "textarea",
      "title": "神马付签名"
    },
    model: {
      value: (_vm.params.sign),
      callback: function($$v) {
        _vm.$set(_vm.params, "sign", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.sign"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "微信/支付宝结算手续费率",
      "placeholder": "如：0.006"
    },
    model: {
      value: (_vm.params.rate),
      callback: function($$v) {
        _vm.$set(_vm.params, "rate", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.rate"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "刷卡结算手续费率",
      "placeholder": "如：0.006"
    },
    model: {
      value: (_vm.params.car_rate),
      callback: function($$v) {
        _vm.$set(_vm.params, "car_rate", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.car_rate"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "结算周期",
      "placeholder": "T+1 请填 1、T+2 请填 2"
    },
    model: {
      value: (_vm.params.settlement_cycle),
      callback: function($$v) {
        _vm.$set(_vm.params, "settlement_cycle", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.settlement_cycle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx btn-adaption"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleAddBtn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("商家logo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-fdd49312","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mg/business/BusinessEdit.vue
// module id = 897
// module chunks = 0